import { useAemConfig } from '@as-react/common-components';
import { useGetTealiumProfile } from '@as-react/common-queries';
import { TealiumCustomerIdentity } from '@as-react/common-types';
import { CookieUtil } from '@as-react/common-utils';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { makeGetHasConsentOnMarketingCookies } from '../redux/cookieConsent/selectors/CookieConsentSelector';
export const useTealiumCustomerIdentification = () => {
    const dispatch = useDispatch();
    const { defaultRequestParams } = useAemConfig();
    const consentMarketing = useSelector(makeGetHasConsentOnMarketingCookies());
    const userID = CookieUtil.get('_UUID') || CookieUtil.get('customerID');
    const { data: customerInfo, isError } = useGetTealiumProfile({
        mainWebshop: defaultRequestParams.mainWebshop,
    }, undefined, {
        query: {
            enabled: consentMarketing && !!userID,
        },
    });
    useEffect(() => {
        if (!consentMarketing || !userID || isError) {
            dispatch(analyticsActions.customerIdentification({ identity: TealiumCustomerIdentity.ANONYMOUS }));
            return;
        }
        if (customerInfo) {
            dispatch(analyticsActions.customerIdentification({
                identity: TealiumCustomerIdentity.IDENTIFIED,
                customerInfo,
            }));
        }
    }, [consentMarketing, userID, customerInfo, isError, dispatch]);
};
